export class CreateIndustryDto {
    name: string;
    parentIndustry: string

    constructor() {
    }
}
